import { PolicyPlan } from "@covertree/new-business-graphql";

export function mapPolicyPlanToPlanName(policyPlan: PolicyPlan) {
  switch (policyPlan) {
    case PolicyPlan.Gold:
      return "Gold Plan";
    case PolicyPlan.Platinum:
      return "Platinum Plan";
    case PolicyPlan.Silver:
      return "Silver Plan";
    case PolicyPlan.CoverTree:
      return "CoverTree Plan";
  }
}
